import * as React from 'react';
import styled from 'styled-components';
import LoginBackground from '../../../../images/login_background_v2.jpg';
import { MainGrid } from '../../layout/MainGrid';

interface IProps {
  children: React.ReactNode;
}

export const Landing = ({ children }: IProps): React.ReactElement => {
  return (
    <LandingGrid wrapperStyle={{ height: '100vh', paddingTop: 0 }}>
      <Center role='main'>{children}</Center>
    </LandingGrid>
  );
};

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const LandingGrid = styled(MainGrid)`
  height: 100vh;
  padding: 0px;
  background: url(${LoginBackground}) no-repeat center bottom fixed;
  background-color: rgba(0, 0, 0, 0.5);
  background-size: cover;
  overflow-y: auto;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.7),
      rgba(33, 33, 33, 0.6)
    );
    z-index: 0;
  }
`;
